import { green } from '@ant-design/colors';
import {
  CheckCircleOutlined,
  DeleteOutlined,
  EditOutlined,
  FileProtectOutlined,
  LoadingOutlined,
  MinusCircleOutlined
} from '@ant-design/icons';
import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Radio,
  Select,
  Space,
  Spin,
  Switch,
  Table,
  Tooltip,
  Typography,
  message
} from 'antd';
import React, { useEffect, useState } from 'react';
import MapPolygon from '../../components/MapPolygon';
import {
  TIPOS_COMBUSTIBLE,
  TIPOS_USO_VEHICULO_TODOS,
  TIPOS_VEHICULO
} from '../../constants';
import { instanceRef } from '../../utils/axios';

const { Option } = Select;

const InputIconEdit = ({ onClick, loading }) => {
  if (loading) {
    return <LoadingOutlined style={{ color: 'rgba(0,0,0,.45)' }} />;
  }
  return (
    <Tooltip title="Editar">
      <EditOutlined onClick={onClick} style={{ color: 'rgba(0,0,0,.45)' }} />
    </Tooltip>
  );
};

const InputIconEliminar = ({ onClick, loading }) => {
  if (loading) {
    return <LoadingOutlined style={{ color: 'rgba(0,0,0,.45)' }} />;
  }
  return (
    <Button
      type="text"
      icon={<DeleteOutlined />}
      size="middle"
      onClick={onClick}
      style={{ color: 'rgba(0,0,0,.45)' }}
    />
  );
};

const VehiculoYZonaFormModal = ({
  columnName = '',
  title,
  initialValues,
  setControlProducto,
  tipoButton = 'editar',
  setLoading
}) => {
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [marcas, setMarcas] = useState([]);
  const [modelos, setModelos] = useState([]);
  const [anios, setAnios] = useState([]);
  const [antiguedadSelected, setAntiguedadSelected] = useState();
  const [volanteCambiado, setVolanteCambiado] = useState();
  const [importacionDirecta, setImportacionDirecta] = useState();
  const [autorizar, setAutorizar] = useState();
  const [submodelos, setSubmodelos] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [distritos, setDistritos] = useState([]);
  const [points, setPoints] = useState();
  async function getDepartamentos() {
    try {
      const response = await instanceRef.instance.get(`data/departamentos`);
      const orderedDepartamentos = response.data.data.sort(function test(a, b) {
        if (a.descripcion < b.descripcion) {
          return -1;
        }
        if (a.descripcion > b.descripcion) {
          return 1;
        }
        return 0;
      });
      setDepartamentos(orderedDepartamentos);
      // getDistritos(fields?.id_departamento);
    } catch (error) {
      // error
    }
  }

  async function getDistritos() {
    try {
      const departamento = form.getFieldValue('departamento');
      if (departamento && departamento.id) {
        const response = await instanceRef.instance.get(
          `data/distritos?departamento=${departamento.id}`
        );
        const orderedDistritos = response.data.data.sort(function test(a, b) {
          if (a.descripcion < b.descripcion) {
            return -1;
          }
          if (a.descripcion > b.descripcion) {
            return 1;
          }
          return 0;
        });
        setDistritos(orderedDistritos);
      }
    } catch (error) {
      // error
    }
  }
  const showModal = () => {
    if (
      columnName === 'marca' ||
      columnName === 'modelo' ||
      columnName === 'submodelo'
    ) {
      getMarcas();
    }
    if (columnName === 'departamento' || columnName === 'distrito') {
      getDepartamentos();
    }
    if (columnName === 'zona') {
      const coordZonaList = initialValues.poligono?.coordinates[0];
      const pointList = [];
      if (coordZonaList) {
        coordZonaList.map((item) =>
          pointList.push({ lat: item[0], lng: item[1] })
        );
        setPoints(pointList);
      }
    }
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    const values = form.getFieldsValue();
    let newValues = {};
    if (columnName === 'marca' && values.marca.id !== initialValues.id_marca) {
      const marcaSelected = marcas.find((item) => item.id === values.marca.id);
      newValues = {
        id_marca: values.marca.id,
        marca: marcaSelected,
        id_modelo: null,
        modelo: null,
        id_submodelo: null,
        submodelo: null,
        editado: !!initialValues.id
      };
    } else if (
      columnName === 'modelo' &&
      values.id_modelo !== initialValues.id_modelo
    ) {
      newValues = {
        id_marca: values.marca.id,
        marca: marcas.find((item) => item.id === values.marca.id),
        id_modelo: values.modelo.id,
        modelo: modelos.find((item) => item.id === values.modelo.id),
        id_submodelo: null,
        submodelo: null,
        editado: !!initialValues.id
      };
    } else if (
      columnName === 'submodelo' &&
      ((initialValues.id_submodelo &&
        values.id_submodelo !== initialValues.id_submodelo) ||
        !initialValues.id_submodelo)
    ) {
      newValues = {
        id_marca: values.marca.id,
        marca: marcas.find((item) => item.id === values.marca.id),
        id_modelo: values.modelo.id,
        modelo: modelos.find((item) => item.id === values.modelo.id),
        id_submodelo: values.submodelo.id,
        submodelo: submodelos.find((item) => item.id === values.submodelo.id),
        editado: !!initialValues.id
      };
    } else if (columnName === 'anho') {
      if (antiguedadSelected) {
        newValues = {
          cantidad_anho_antiguedad: values.cantidad_anho_antiguedad,
          anho_desde: null,
          anho_hasta: null,
          editado: !!initialValues.id
        };
      } else {
        if (
          values.anho_desde &&
          values.anho_hasta &&
          values.anho_desde > values.anho_hasta
        ) {
          message.warning('Verificar rango de años');
          return;
        }
        newValues = {
          anho_desde: values.anho_desde,
          anho_hasta: values.anho_hasta,
          cantidad_anho_antiguedad: null,
          editado: !!initialValues.id
        };
      }
    } else if (columnName === 'combustible') {
      newValues = {
        tipo_combustible: values.tipo_combustible,
        editado: !!initialValues.id
      };
    } else if (columnName === 'volante_cambiado') {
      newValues = {
        volante_cambiado: volanteCambiado,
        editado: !!initialValues.id
      };
    } else if (columnName === 'tipo_vehiculo') {
      newValues = {
        tipo_vehiculo: values.tipo_vehiculo,
        editado: !!initialValues.id
      };
    } else if (columnName === 'tipo_uso') {
      newValues = {
        tipo_uso: values.tipo_uso,
        editado: !!initialValues.id
      };
    } else if (columnName === 'importacion_directa') {
      newValues = {
        importacion_directa: importacionDirecta,
        editado: !!initialValues.id
      };
    } else if (
      columnName === 'departamento' &&
      values.departamento.id !== initialValues.id_departamento
    ) {
      const departamentoSelected = departamentos.find(
        (item) => item.id === values.departamento.id
      );
      newValues = {
        id_departamento: values.departamento.id,
        departamento: departamentoSelected,
        id_distrito: null,
        distrito: null,
        editado: !!initialValues.id
      };
    } else if (
      columnName === 'distrito' &&
      values.distrito.id !== initialValues.id_distrito
    ) {
      newValues = {
        id_departamento: values.departamento.id,
        departamento: departamentos.find(
          (item) => item.id === values.departamento.id
        ),
        id_distrito: values.distrito.id,
        distrito: distritos.find((item) => item.id === values.distrito.id),

        editado: !!initialValues.id
      };
    } else if (columnName === 'zona') {
      try {
        await form.validateFields();
      } catch (err) {
        return;
      }
      if (!points) {
        message.warning('Debe ubicar la zona en el mapa');
        return;
      }
      const listTotal = [];
      const pointsActualizados = [...points];
      pointsActualizados.forEach((item) => {
        listTotal.push([item.lat, item.lng]);
      });

      newValues = {
        editado: !!initialValues.id,

        descripcion_poligono: values.descripcion_poligono,
        poligono: {
          type: 'Polygon',
          coordinates: [listTotal]
        }
      };
    } else if (columnName === 'eliminar') {
      newValues = {
        eliminado: true
      };
    } else if (columnName === 'excluyente') {
      newValues = {
        excluyente: values.excluyente,
        editado: !!initialValues.id
      };
    }
    const newControlProducto = {
      ...initialValues,
      ...newValues
    };
    form.setFieldsValue(newControlProducto);
    setControlProducto(newControlProducto);

    setIsModalOpen(false);
  };

  const handleCancel = () => {
    clearAll();
    setIsModalOpen(false);
  };
  const clearAll = () => {};

  async function getMarcas() {
    try {
      const response = await instanceRef.instance.get(`data/marcas`);
      const orderedMarcas = response.data.data.sort(function test(a, b) {
        if (a.descripcion < b.descripcion) {
          return -1;
        }
        if (a.descripcion > b.descripcion) {
          return 1;
        }
        return 0;
      });
      setMarcas(orderedMarcas);
    } catch (error) {
      // error
    }
  }

  async function getModelos() {
    try {
      const marca = form && form.getFieldValue('marca');
      if (marca && marca.id) {
        const response = await instanceRef.instance.get(
          `data/modelos?marca=${marca.id}`
        );
        const orderedModelos = response.data.data
          ? response.data.data.sort(function test(a, b) {
              if (a.descripcion < b.descripcion) {
                return -1;
              }
              if (a.descripcion > b.descripcion) {
                return 1;
              }
              return 0;
            })
          : [];

        setModelos(orderedModelos);
      }
    } catch (error) {
      // error
    }
  }

  async function getAnios() {
    try {
      const currentYear = Number(new Date().getFullYear() + 1);
      const firstYear = Number(1990);
      const aniosList = [null];

      for (let i = firstYear; i < currentYear; i += 1) {
        aniosList.push(i);
      }

      const orderedAnios = aniosList.sort(function test(a, b) {
        if (a < b) {
          return 1;
        }
        if (a > b) {
          return -1;
        }
        return 0;
      });

      setAnios(orderedAnios);
    } catch (error) {
      // error
    }
  }

  async function getSubmodelos(modelo) {
    try {
      // setLoading(true);
      const response = await instanceRef.instance.get(
        `data/submodelos/modelo`,
        {
          params: { modelo }
        }
      );
      const orderedSubmodelos = response.data.data
        ? response.data.data.sort(function test(a, b) {
            if (a.descripcion < b.descripcion) {
              return -1;
            }
            if (a.descripcion > b.descripcion) {
              return 1;
            }
            return 0;
          })
        : [];
      setSubmodelos(orderedSubmodelos);
    } catch (error) {
      // error
    }
    setLoading(false);
  }

  useEffect(() => {
    if (departamentos) {
      getDistritos();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [departamentos]);

  useEffect(() => {
    if (modelos && form && modelos.length > 0) {
      const values = form.getFieldsValue();
      if (values.modelo) {
        getSubmodelos(values.modelo.id);
      } else if (initialValues && initialValues.modelo) {
        getSubmodelos(initialValues.modelo.id);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modelos, form]);

  useEffect(() => {
    if (marcas && form.getFieldValue('marca')) {
      getModelos();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [marcas]);

  useEffect(() => {
    if (initialValues && !initialValues.eliminado) {
      const values = {
        ...initialValues,
        opcion_ingresar_anho: initialValues.cantidad_anho_antiguedad
          ? 'antiguedad'
          : 'anho'
      };
      form.setFieldsValue(values);
      setAntiguedadSelected(!!initialValues.cantidad_anho_antiguedad);
      setVolanteCambiado(initialValues.volante_cambiado);
      setImportacionDirecta(initialValues.importacion_directa);
      setAutorizar(initialValues.autorizacion);
    }

    if (columnName === 'anho') {
      getAnios();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (initialValues && !initialValues.eliminado) {
      form.setFieldsValue(initialValues);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValues]);

  return (
    <>
      {tipoButton === 'editar' && <InputIconEdit onClick={showModal} />}
      {tipoButton === 'eliminar' && <InputIconEliminar onClick={showModal} />}
      {tipoButton === 'exluyente' && (
        <Tooltip title={!initialValues.excluyente ? 'Incluye' : 'Excluye'}>
          <Button
            type="text"
            style={!initialValues.excluyente ? { color: green.primary } : {}}
            danger={initialValues.excluyente}
            icon={
              !initialValues.excluyente ? (
                <CheckCircleOutlined />
              ) : (
                <MinusCircleOutlined />
              )
            }
            size="middle"
            onClick={showModal}
          />
        </Tooltip>
      )}
      <Modal
        // eslint-disable-next-line react/destructuring-assignment
        title={`${
          (initialValues && !initialValues.id) || columnName === 'eliminar'
            ? ''
            : 'Editar'
        } ${title}`}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={1000}
        okText={columnName === 'eliminar' && 'Si'}
        cancelText={columnName === 'eliminar' && 'No'}
      >
        <Form
          name="controlProductoVehiculoZona"
          initialValues={initialValues}
          wrapperCol={{ span: 16 }}
          autoComplete="off"
          form={form}
        >
          {columnName === 'marca' && (
            <Form.Item
              label="Marca"
              name={['marca', 'id']}
              rules={[{ required: true }]}
            >
              <Select
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                style={{ width: '100%' }}
                optionFilterProp="children"
              >
                {marcas.map((item) => (
                  <Option key={item.id} value={item.id}>
                    {item.descripcion}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          )}
          {columnName === 'modelo' && (
            <>
              {modelos.length > 0 && (
                <>
                  <Form.Item
                    label="Marca"
                    name={['marca', 'id']}
                    rules={[{ required: true }]}
                  >
                    <Select
                      showSearch
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      style={{ width: '100%' }}
                      optionFilterProp="children"
                      onChange={(value) => {
                        form.setFieldsValue({
                          id_marca: value,
                          id_modelo: null,
                          id_submodelo: null
                        });
                        getModelos();
                      }}
                      // disabled
                    >
                      {marcas.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.descripcion}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item label="Modelo" name={['modelo', 'id']}>
                    <Select
                      showSearch
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      style={{ width: '100%' }}
                      placeholder="Elegir modelo"
                      onChange={(value) => {
                        form.setFieldsValue({
                          id_modelo: value,
                          id_submodelo: null
                        });
                        getSubmodelos(value);
                      }}
                    >
                      {modelos.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.descripcion}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </>
              )}
            </>
          )}

          {columnName === 'submodelo' && (
            <>
              <Form.Item
                label="Marca"
                name={['marca', 'id']}
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  style={{ width: '100%' }}
                  optionFilterProp="children"
                  onChange={(value) => {
                    form.setFieldsValue({
                      id_marca: value,
                      id_modelo: null,
                      id_submodelo: null
                    });
                    getModelos();
                  }}
                >
                  {marcas.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.descripcion}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <>
                {modelos.length > 0 && (
                  <Form.Item
                    label="Modelo"
                    name={['modelo', 'id']}
                    rules={[{ required: true }]}
                  >
                    <Select
                      showSearch
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      style={{ width: '100%' }}
                      placeholder="Elegir modelo"
                      onChange={(value) => {
                        form.setFieldsValue({
                          // id_marca: value,
                          id_modelo: value,
                          id_submodelo: null
                        });
                        getSubmodelos(value);
                      }}
                    >
                      {modelos.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.descripcion}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
                {submodelos.length > 0 && (
                  <Form.Item
                    label="Submodelo"
                    name={['submodelo', 'id']}
                    rules={[{ required: true }]}
                  >
                    <Select
                      showSearch
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      style={{ width: '100%' }}
                      placeholder="Elegir submodelo"
                    >
                      {submodelos.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.descripcion}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
              </>
            </>
          )}

          {columnName === 'anho' && (
            <Form.Item
              label="Configurar por"
              name={['opcion_ingresar_anho']}
              onChange={(e) => {
                if (e.target.value === 'antiguedad') {
                  setAntiguedadSelected(true);
                } else {
                  setAntiguedadSelected(false);
                }
              }}
            >
              <Radio.Group>
                <Space>
                  <Radio value="anho">Rango de años</Radio>
                  <Radio value="antiguedad">Antigüedad</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>
          )}

          {columnName === 'anho' && !antiguedadSelected && (
            <>
              <Form.Item label="Desde" name="anho_desde">
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  style={{ width: '100%' }}
                  placeholder="Elegir Año"
                >
                  {anios.map((item) => (
                    <Option key={item} value={item}>
                      {item}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item label="Hasta" name="anho_hasta">
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  style={{ width: '100%' }}
                  placeholder="Elegir Año"
                >
                  {anios.map((item) => (
                    <Option key={item} value={item}>
                      {item}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </>
          )}

          {columnName === 'anho' && antiguedadSelected && (
            <>
              <Form.Item
                label="Antigüedad máxima en años"
                name="cantidad_anho_antiguedad"
              >
                <InputNumber min={1} />
              </Form.Item>
            </>
          )}
          {columnName === 'combustible' && (
            <Form.Item label="Combustible" name={['tipo_combustible']}>
              <Select
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                style={{ width: '100%' }}
                placeholder="Elegir"
              >
                {TIPOS_COMBUSTIBLE.map((item) => (
                  <Option key={item.codigo} value={item.codigo}>
                    {item.descripcion}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          )}
          {columnName === 'volante_cambiado' && (
            <Form.Item label="Volante Cambiado" valuePropName="checked">
              <Switch
                checkedChildren="Si"
                unCheckedChildren="No"
                checked={volanteCambiado}
                onChange={(value) => setVolanteCambiado(!!value)}
              />
            </Form.Item>
          )}

          {columnName === 'tipo_vehiculo' && (
            <Form.Item label="Tipo" name={['tipo_vehiculo']}>
              <Select
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                style={{ width: '100%' }}
                placeholder="Elegir"
              >
                {TIPOS_VEHICULO.map((item) => (
                  <Option key={item} value={item}>
                    {item}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          )}

          {columnName === 'importacion_directa' && (
            <Form.Item label="Importación Directa" valuePropName="checked">
              <Switch
                checkedChildren="Si"
                unCheckedChildren="No"
                checked={importacionDirecta}
                onChange={(value) => setImportacionDirecta(!!value)}
              />
            </Form.Item>
          )}

          {columnName === 'tipo_uso' && (
            <Form.Item label="Tipo de Uso" name={['tipo_uso']}>
              <Select
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.codigo.toLowerCase()) >= 0
                }
                style={{ width: '100%' }}
                placeholder="Elegir"
              >
                {TIPOS_USO_VEHICULO_TODOS.map(
                  (item) =>
                    item.codigo !== 'OTROS' && (
                      <Option key={item.codigo} value={item.codigo}>
                        {item.codigo}
                      </Option>
                    )
                )}
              </Select>
            </Form.Item>
          )}

          {(columnName === 'departamento' || columnName === 'distrito') && (
            <Col xs={24} md={24} align="start">
              <Form.Item
                label="Departamento"
                name={['departamento', 'id']}
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  style={{ width: '100%' }}
                  optionFilterProp="children"
                  /* disabled={
                    initialValues &&
                    initialValues.id_departamento &&
                    columnName === 'distrito'
                  } */
                  onChange={(value) => {
                    form.setFieldsValue({
                      id_departamento: value,
                      id_distrito: null
                    });
                    getDistritos();
                  }}
                >
                  {departamentos.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.descripcion}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          )}
          {columnName === 'distrito' && (
            <Col xs={24} md={24} align="start">
              <Form.Item
                label="Ciudad"
                name={['distrito', 'id']}
                rules={[{ required: true }]}
              >
                <Select
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  style={{ width: '100%' }}
                  placeholder="Elegir ciudad"
                >
                  {distritos.map((item) => (
                    <Option key={item.id} value={item.id}>
                      {item.descripcion}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          )}

          {columnName === 'zona' && (
            <Form.Item
              label="Descripción"
              name="descripcion_poligono"
              rules={[{ required: true }]}
            >
              <Input />
            </Form.Item>
          )}

          {columnName === 'autorizacion' && (
            <Form.Item
              label="¿Desea que se realice una Autorización?"
              valuePropName="checked"
            >
              <Switch
                checkedChildren="Si"
                unCheckedChildren="No"
                checked={autorizar}
                onChange={(value) => setAutorizar(!!value)}
              />
            </Form.Item>
          )}
          {columnName === 'excluyente' && (
            <Form.Item
              label="¿Desea excluir los planes que coincidan con estas características?"
              valuePropName="checked"
              name="excluyente"
            >
              <Switch checkedChildren="Si" unCheckedChildren="No" />
            </Form.Item>
          )}

          {columnName === 'recargo' && (
            <Form.Item
              label="Porcentaje de Recargo"
              name="recargo"
              normalize={(value) => {
                if (Number(value) > 100) {
                  return 100;
                }
                if (Number(value) < 0) {
                  return 0;
                }
                return value;
              }}
            >
              <Input
                min={0}
                max={100}
                step={0.1}
                type="number"
                suffix="%"
                style={{ width: 100, textAlign: 'end' }}
              />
            </Form.Item>
          )}

          {columnName === 'eliminar' && (
            <p>
              ¿Está seguro? Se eliminará toda la información del Control
              Producto
            </p>
          )}
        </Form>

        {columnName === 'zona' && <MapPolygon {...{ points, setPoints }} />}
      </Modal>
    </>
  );
};

const PlanControlProductoList = ({
  esVehiculo,
  list,
  setList,
  idAutorizacionConfig,
  setLoading,
  producto
}) => {
  const [count, setCount] = useState();
  const [controlProductoList, setControlProductoList] = useState([]);
  const [controlProducto, setControlProducto] = useState();
  const columnsVehiculoZona = [
    ...(esVehiculo
      ? [
          {
            title: 'Marca',
            key: 'marca',
            align: 'right',
            render: (record) => {
              const { marca } = record;
              return (
                <Space>
                  {(marca && marca.descripcion) || ''}
                  <VehiculoYZonaFormModal
                    columnName="marca"
                    title="Marca"
                    initialValues={record}
                    {...{
                      setControlProducto,
                      setLoading
                    }}
                  />
                </Space>
              );
            }
          },
          {
            title: 'Modelo',
            key: 'modelo',
            align: 'right',
            render: (record) => {
              const { modelo } = record;
              return (
                <Space>
                  {(modelo && modelo.descripcion) || ''}
                  <VehiculoYZonaFormModal
                    columnName="modelo"
                    title="Modelo"
                    initialValues={record}
                    {...{
                      setControlProducto,
                      setLoading
                    }}
                  />
                </Space>
              );
            }
          },
          {
            title: 'Submodelo',
            key: 'submodelo',
            align: 'right',
            render: (record) => {
              const { submodelo } = record;
              return (
                <Space>
                  {(submodelo && submodelo.descripcion) || ''}
                  <VehiculoYZonaFormModal
                    columnName="submodelo"
                    title="Submodelo"
                    initialValues={record}
                    {...{
                      setControlProducto,
                      setLoading
                    }}
                  />
                </Space>
              );
            }
          },
          {
            title: 'Año',
            key: 'anho',
            align: 'right',
            render: (record) => {
              const {
                anho_desde,
                anho_hasta,
                cantidad_anho_antiguedad
              } = record;
              let anho =
                anho_desde || anho_hasta
                  ? `[${anho_desde || 'Sin definir'} - ${
                      anho_hasta || 'Sin definir'
                    }]`
                  : '';
              if (cantidad_anho_antiguedad) {
                anho = cantidad_anho_antiguedad;
              }
              return (
                <Space>
                  {(
                    <Typography.Text style={{ whiteSpace: 'nowrap' }}>
                      {anho}
                    </Typography.Text>
                  ) || ''}
                  <VehiculoYZonaFormModal
                    columnName="anho"
                    title="Rango de años / Antigüedad"
                    initialValues={record}
                    {...{
                      setControlProducto,
                      setLoading
                    }}
                  />
                </Space>
              );
            }
          },
          {
            title: 'Combustible',
            key: 'tipo_combustible',
            align: 'right',
            render: (record) => {
              const { tipo_combustible } = record;

              return (
                <Space>
                  {tipo_combustible || ''}
                  <VehiculoYZonaFormModal
                    columnName="combustible"
                    title="Combustible"
                    initialValues={record}
                    {...{
                      setControlProducto,
                      setLoading
                    }}
                  />
                </Space>
              );
            }
          },
          {
            title: 'Volante Cambiado',
            key: 'volante_cambiado',
            align: 'right',
            render: (record) => {
              const { volante_cambiado } = record;
              let volanteCambiado = '';
              if (volante_cambiado !== null) {
                volanteCambiado = volante_cambiado ? 'Si' : 'No';
              }
              return (
                <Space>
                  {volanteCambiado}
                  <VehiculoYZonaFormModal
                    columnName="volante_cambiado"
                    title="Volante Cambiado"
                    initialValues={record}
                    {...{
                      setControlProducto,
                      setLoading
                    }}
                  />
                </Space>
              );
            }
          },
          {
            title: 'Importación Directa',
            key: 'importacion_directa',
            align: 'right',
            render: (record) => {
              const { importacion_directa } = record;
              let importacionDirecta = '';
              if (importacion_directa !== null) {
                importacionDirecta = importacion_directa ? 'Si' : 'No';
              }
              return (
                <Space>
                  {importacionDirecta}
                  <VehiculoYZonaFormModal
                    columnName="importacion_directa"
                    title="Importación Directa"
                    initialValues={record}
                    {...{
                      setControlProducto,
                      setLoading
                    }}
                  />
                </Space>
              );
            }
          },
          {
            title: 'Tipo',
            key: 'tipo_vehiculo',
            align: 'right',
            render: (record) => {
              const { tipo_vehiculo } = record;

              return (
                <Space>
                  {tipo_vehiculo || ''}
                  <VehiculoYZonaFormModal
                    columnName="tipo_vehiculo"
                    title="Tipo"
                    initialValues={record}
                    {...{
                      setControlProducto,
                      setLoading
                    }}
                  />
                </Space>
              );
            }
          },
          {
            title: 'Tipo de Uso',
            key: 'tipo_uso',
            align: 'right',
            render: (record) => {
              const { tipo_uso } = record;

              return (
                <Space>
                  {tipo_uso || ''}
                  <VehiculoYZonaFormModal
                    columnName="tipo_uso"
                    title="Tipo de Uso"
                    initialValues={record}
                    {...{
                      setControlProducto,
                      setLoading
                    }}
                  />
                </Space>
              );
            }
          }
        ]
      : []),

    {
      title: 'Departamento',
      key: 'departamento',
      align: 'right',
      render: (record) => {
        const { departamento } = record;
        return (
          <Space>
            {(departamento && departamento.descripcion) || ''}
            <VehiculoYZonaFormModal
              columnName="departamento"
              title="Departamento"
              initialValues={record}
              {...{
                setControlProducto
              }}
            />
          </Space>
        );
      }
    },
    {
      title: 'Ciudad',
      key: 'distrito',
      align: 'right',
      render: (record) => {
        const { distrito } = record;
        return (
          <Space>
            {(distrito && distrito.descripcion) || ''}
            <VehiculoYZonaFormModal
              columnName="distrito"
              title="Ciudad"
              initialValues={record}
              {...{
                setControlProducto
              }}
            />
          </Space>
        );
      }
    },
    ...(Number(producto) === 4 ||
    Number(producto) === 5 ||
    Number(producto) === 6
      ? [
          {
            title: 'Zona',
            key: 'zona',
            align: 'right',
            render: (record) => {
              const { descripcion_poligono } = record;
              return (
                <Space>
                  {descripcion_poligono || ''}
                  <VehiculoYZonaFormModal
                    columnName="zona"
                    title="Zona"
                    initialValues={record}
                    {...{
                      setControlProducto
                    }}
                  />
                </Space>
              );
            }
          }
        ]
      : []),
    {
      title: 'Acciones',
      key: 'action',
      width: '10px',
      align: 'left',
      render: (record) => {
        return (
          <Space>
            <Tooltip title="Eliminar" key="eliminar">
              <VehiculoYZonaFormModal
                columnName="eliminar"
                title="Eliminar"
                initialValues={record}
                {...{
                  setControlProducto,
                  setLoading
                }}
                tipoButton="eliminar"
              />
            </Tooltip>
            <VehiculoYZonaFormModal
              columnName="excluyente"
              title="Excluir"
              initialValues={record}
              {...{
                setControlProducto,
                setLoading
              }}
              tipoButton="exluyente"
            />
          </Space>
        );
      }
    }
  ];

  const handleAdd = () => {
    const newRow = count + 1;
    const newData = {
      key: newRow,
      row: newRow,
      marca: null,
      modelo: null,
      anho_desde: null,
      anho_hasta: null,
      combustible: null,
      volante_cambiado: null,
      importacion_directa: null,
      tipo_vehiculo: null,
      tipo_uso: null,
      excluyente: null,
      coberturas: [],
      departamento: null,
      distrito: null,
      poligono: null,
      id_autorizacion_config: idAutorizacionConfig
    };

    setControlProductoList([...controlProductoList, newData]);
    setCount(count + 1);
  };

  useEffect(() => {
    if (controlProducto) {
      const newDataList = controlProductoList.map((item) => {
        if (
          (item.id && controlProducto.id && item.id === controlProducto.id) ||
          (item.row && controlProducto.row && item.row === controlProducto.row)
        ) {
          return controlProducto;
        }
        return item;
      });
      setControlProductoList(newDataList);
      setList(newDataList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [controlProducto]);

  useEffect(() => {
    if (list) {
      const listOrdenado = list
        .filter((item) => !item.eliminado)
        .sort((n1, n2) => n1.id - n2.id);

      const listWithRow = [];
      for (let i = 0; i < listOrdenado.length; i += 1) {
        const element = listOrdenado[i];
        element.row = i + 1;
        listWithRow.push(element);
      }
      setControlProductoList(listWithRow);
      setCount(listWithRow.length);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list]);

  return (
    <>
      <Button onClick={handleAdd} type="primary" style={{ marginBottom: 16 }}>
        Agregar
      </Button>
      {controlProductoList && controlProductoList.length > 0 && (
        <Table
          fixed
          scroll
          style={{ width: '100%' }}
          bordered
          dataSource={controlProductoList.filter((item) => !item.eliminado)}
          columns={columnsVehiculoZona}
          pagination
          size="large"
          rowKey={(record) => record && (record.id || record.row)}
        />
      )}
    </>
  );
};

const PlanControlProductoModal = ({
  esVehiculo,
  idAutorizacionConfig,
  controlProductoList,
  setControlProductoList,
  loading,
  setLoading,
  open,
  setOpen,
  mostrarAcciones,
  moneda,
  producto
}) => {
  const [isModalOpen, setIsModalOpen] = useState(open || false);
  const [list, setList] = useState([]);

  const showModal = () => {
    if (open !== undefined) {
      setOpen(true);
    } else {
      setIsModalOpen(true);
    }
  };

  const handleOk = () => {
    setControlProductoList(list);
    if (open !== undefined) {
      setOpen(false);
    } else {
      setIsModalOpen(false);
    }
  };

  const handleCancel = () => {
    // setList(controlProductoList);
    // setControlProductoList([]);
    if (open !== undefined) {
      setOpen(false);
    } else {
      setIsModalOpen(false);
    }
  };

  useEffect(() => {
    setList(controlProductoList);
  }, [controlProductoList]);

  useEffect(() => {
    if (open !== undefined) {
      setIsModalOpen(open);
    }
  }, [open]);

  return (
    <>
      {open === undefined && (
        <Tooltip title="Control Producto">
          <Button
            icon={<FileProtectOutlined />}
            type="text"
            size="middle"
            onClick={showModal}
          />
        </Tooltip>
      )}

      <Modal
        title="Lista de Control Producto"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        width={1500}
        closable={false}
      >
        <Spin spinning={loading} delay={500} size="large" tip="Cargando...">
          <PlanControlProductoList
            esVehiculo={esVehiculo}
            list={list}
            setList={setList}
            idAutorizacionConfig={idAutorizacionConfig}
            setLoading={setLoading}
            mostrarAcciones={mostrarAcciones}
            moneda={moneda}
            producto={producto}
            // idAseguradoraProducto={idAseguradoraProducto}
          />
        </Spin>
      </Modal>
    </>
  );
};
export default PlanControlProductoModal;
